module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.songCategory), function(row, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box catalog-box"
    }, [(row.id == 6) ? _c('a', {
      attrs: {
        "href": '/topic'
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])]) : _c('a', {
      attrs: {
        "href": '/songCategory/' + row.id
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v("創造永遠美好回憶，值得花時間了解、選擇")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("婚禮歌曲魔力無窮，聆聽獨特愛情印記")])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', [_vm._v("一場真正的婚宴起始於求婚應允，接著開始籌備婚禮。")]), _vm._v(" "), _c('p', [_vm._v("我們針對婚禮流程中的<求婚/迎賓>、<新人進場>、<愛情回顧>、<婚宴配樂>、<送客/蜜月>，分別精心挑選婚禮歌曲和音樂、介紹每首婚禮歌曲，\n                              並附上曾經使用過該婚禮歌曲的婚禮 video，希望每對新人或婚禮顧問，都能找到專屬於自己和伴侶一生回味無窮的婚禮歌曲。  ")]), _vm._v(" "), _c('p', [_vm._v("除此之外，我們也為了想要有個主題式婚禮的新人，花費時間尋找歌詞內涵、歌曲旋律、歌曲數量皆有一定分量的歌者，\n                              讓整場婚禮都能有著一致的調性，如單一歌者、歌曲風格、婚禮氣氛等，這個分類命名為<主題歌曲>，將會陸續推出不同主題的婚禮歌曲推薦。")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("精選分類")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39113a6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SongsCatalog.vue
// module id = 160
// module chunks = 1